const htmlTag = document.getElementsByTagName('html')[0];

export const getScrollWidth = () => innerWidth - document.body.clientWidth + 'px';

export const disableScrollBody = () => {
  if (!htmlTag?.classList?.contains('disable-scroll')) {
    document.body.style.paddingRight = getScrollWidth();
    htmlTag.classList.add('disable-scroll');
  }
};

export const enableScrollBody = () => {
  document.body.style.paddingRight = null;
  htmlTag.classList.remove('disable-scroll');
};
